export default __webpack_public_path__ + "729cbab87cb95c5a2d3b3dd2fb5f3450.png";